class StringParser {
	static capitalize(value = '') {
		return value.charAt(0).toUpperCase() + value.slice(1);
	}

	// Deep trim for form payloads. Walks arrays and plain objects only, so
	// values the API treats as opaque (Date, File, ...) are returned untouched.
	static trimValues(value) {
		if (typeof value === 'string') return value.trim();

		if (Array.isArray(value)) return value.map(StringParser.trimValues);

		if (value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
			return Object.keys(value).reduce((trimmed, key) => {
				trimmed[key] = StringParser.trimValues(value[key]);

				return trimmed;
			}, {});
		}

		return value;
	}
}

export default StringParser;
